<!--
 * @Author: 仙道
 * @Date: 2022-06-18 16:44:24
 * @LastEditTime: 2022-07-02 13:19:44
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/components/jeecgbiz/JSelectModelPoints.vue
-->
<template>
    <j-select-biz-component :width="1000" returnId v-bind="configs" v-on="$listeners" />
</template>

<script>
    import JSelectBizComponent from './JSelectBizComponent'

    export default {
        name: 'JSelectModelPoints',
        components: { JSelectBizComponent },
        props: ['value'],
        data() {
            return {
                settings: {
                    name: '测点',
                    displayKey: 'pointName',
                    valueKey: 'pointCode',
                    returnKeys: ['id', 'pointCode', 'pointName'],
                    listUrl: '/monitor/iotModelPoints/list',
                    queryParamCode: 'pointName',
                    queryParamText: '测点名称',
                    columns: [{
                            title: '测点编码',
                            align: 'center',
                            dataIndex: 'pointCode'
                        },
                        { title: '测点名称', dataIndex: 'pointName', align: 'center', width: '30%', widthRight: '70%' },
                    ]
                }
            }
        },
        computed: {
            configs() {
                return Object.assign({ value: this.value }, this.settings, this.$attrs)
            }
        }
    }
</script>

<style lang="less" scoped></style>